import toArray from "../../types/to-array.js";
import createFlatMapper from "./_create-flat-mapper.js";
/**
 * @function childrenWithClass
 * @param {HTMLElement|HTMLElement[]} elementOrElements element or elements
 * @param {string} className class name to match
 * @returns {HTMLElement[]} children with matching class
 */
const childrenWithClass = createFlatMapper((element, className) => toArray(element.children).filter((child) => child.classList.contains(className)));
export default childrenWithClass;
